import VerifyAccountStat from "./VerifyAccountStat";
import VerifyLiveTrade from "./VerifyLiveTrade";
import { useSelector } from "react-redux";
import "./VerifyMyTradeDashboard.css";
import VerifyTradeStatusCheck from "./VerifyTradeStatusCheck";
import VerifyTradeRanking from "./VerifyTradeRanking";
import DashboardMarketSelectBar from "../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketSelectBar";
import { useDashboardMarket } from "../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";

const VerifyMyTradeDashboard = () => {
  const { user } = useSelector((state) => state.user);
  const { permissionType } = useDashboardMarket();
  const showRanking =
    (user?.role === "leader" && user?.leaderCommunity) ||
    (user?.role === "leader" &&
      !user?.tradeName &&
      !user?.leaderCommunity &&
      user?.isWatchTutorial) ||
    user?.role === "member" ||
    (user?.role === "leader" &&
      user?.activeTutorialScreen?.purposeOfJoining ===
        "Launch Your Own Copy Trade" &&
      !user?.isWatchTutorial);

  return (
    <div className="verifyTradeDashboardPage">
      {permissionType === "both" && <DashboardMarketSelectBar />}
      <div className="firstRow">
        <VerifyAccountStat user={user} showRanking={showRanking} />
        <div className="d-lg-none d-md-none firstRow__mobileLiveTrades">
          <VerifyLiveTrade user={user} />
        </div>
        {showRanking && user?.role === "member" && (
          <VerifyTradeRanking user={user} />
        )}
      </div>
      <div className="d-lg-block d-md-block d-none">
        <VerifyLiveTrade user={user} />
      </div>
      <VerifyTradeStatusCheck user={user} />
    </div>
  );
};

export default VerifyMyTradeDashboard;
